/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Flow Do API
 * API таск-менеджера Flow Do. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorModel,
  FeedBody,
  NotificationSettingInputBody,
  NotificationSettingsOutputBody,
  NotificationsListParams,
  PushStatusOutputBody,
  PushStatusParams,
  PushSubscribeInputBody,
  PushUnsubscribeParams,
  TelegramBoardsOutputBody,
  TelegramCodeOutputBody,
  TelegramInboxInputBody,
  TelegramStatusOutputBody,
  UnreadOutputBody
} from '../model';

import { apiFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type notificationSettingsGetResponse200 = {
  data: NotificationSettingsOutputBody
  status: 200
}

export type notificationSettingsGetResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type notificationSettingsGetResponseSuccess = (notificationSettingsGetResponse200) & {
  headers: Headers;
};
export type notificationSettingsGetResponseError = (notificationSettingsGetResponseDefault) & {
  headers: Headers;
};

export type notificationSettingsGetResponse = (notificationSettingsGetResponseSuccess | notificationSettingsGetResponseError)

export const getNotificationSettingsGetUrl = () => {




  return `/me/notification-settings`
}

/**
 * @summary Мои настройки уведомлений
 */
export const notificationSettingsGet = async ( options?: Parameters<typeof apiFetch>[1]): Promise<notificationSettingsGetResponse> => {

  return apiFetch<notificationSettingsGetResponse>(getNotificationSettingsGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getNotificationSettingsGetQueryKey = () => {
    return [
    `/me/notification-settings`
    ] as const;
    }


export const getNotificationSettingsGetQueryOptions = <TData = Awaited<ReturnType<typeof notificationSettingsGet>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationSettingsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationSettingsGet>>> = ({ signal }) => notificationSettingsGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationSettingsGetQueryResult = NonNullable<Awaited<ReturnType<typeof notificationSettingsGet>>>
export type NotificationSettingsGetQueryError = ErrorModel


export function useNotificationSettingsGet<TData = Awaited<ReturnType<typeof notificationSettingsGet>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationSettingsGet>>,
          TError,
          Awaited<ReturnType<typeof notificationSettingsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationSettingsGet<TData = Awaited<ReturnType<typeof notificationSettingsGet>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationSettingsGet>>,
          TError,
          Awaited<ReturnType<typeof notificationSettingsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationSettingsGet<TData = Awaited<ReturnType<typeof notificationSettingsGet>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Мои настройки уведомлений
 */

export function useNotificationSettingsGet<TData = Awaited<ReturnType<typeof notificationSettingsGet>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationSettingsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type notificationSettingsUpdateResponse200 = {
  data: NotificationSettingsOutputBody
  status: 200
}

export type notificationSettingsUpdateResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type notificationSettingsUpdateResponseSuccess = (notificationSettingsUpdateResponse200) & {
  headers: Headers;
};
export type notificationSettingsUpdateResponseError = (notificationSettingsUpdateResponseDefault) & {
  headers: Headers;
};

export type notificationSettingsUpdateResponse = (notificationSettingsUpdateResponseSuccess | notificationSettingsUpdateResponseError)

export const getNotificationSettingsUpdateUrl = () => {




  return `/me/notification-settings`
}

/**
 * @summary Включить или выключить событие в канале
 */
export const notificationSettingsUpdate = async (notificationSettingInputBody: NonReadonly<NotificationSettingInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<notificationSettingsUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<notificationSettingsUpdateResponse>(getNotificationSettingsUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(notificationSettingInputBody)
  }
);}





export const getNotificationSettingsUpdateQueryKey = (notificationSettingInputBody?: NonReadonly<NotificationSettingInputBody>,) => {
    return [
    'PUT', `/me/notification-settings`, notificationSettingInputBody
    ] as const;
    }


export const getNotificationSettingsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof notificationSettingsUpdate>>, TError = ErrorModel>(notificationSettingInputBody: NonReadonly<NotificationSettingInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsUpdate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationSettingsUpdateQueryKey(notificationSettingInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationSettingsUpdate>>> = ({ signal }) => notificationSettingsUpdate(notificationSettingInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationSettingsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof notificationSettingsUpdate>>>
export type NotificationSettingsUpdateQueryError = ErrorModel


export function useNotificationSettingsUpdate<TData = Awaited<ReturnType<typeof notificationSettingsUpdate>>, TError = ErrorModel>(
 notificationSettingInputBody: NonReadonly<NotificationSettingInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationSettingsUpdate>>,
          TError,
          Awaited<ReturnType<typeof notificationSettingsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationSettingsUpdate<TData = Awaited<ReturnType<typeof notificationSettingsUpdate>>, TError = ErrorModel>(
 notificationSettingInputBody: NonReadonly<NotificationSettingInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationSettingsUpdate>>,
          TError,
          Awaited<ReturnType<typeof notificationSettingsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationSettingsUpdate<TData = Awaited<ReturnType<typeof notificationSettingsUpdate>>, TError = ErrorModel>(
 notificationSettingInputBody: NonReadonly<NotificationSettingInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsUpdate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Включить или выключить событие в канале
 */

export function useNotificationSettingsUpdate<TData = Awaited<ReturnType<typeof notificationSettingsUpdate>>, TError = ErrorModel>(
 notificationSettingInputBody: NonReadonly<NotificationSettingInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationSettingsUpdate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationSettingsUpdateQueryOptions(notificationSettingInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type pushUnsubscribeResponse204 = {
  data: void
  status: 204
}

export type pushUnsubscribeResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 204>
}

export type pushUnsubscribeResponseSuccess = (pushUnsubscribeResponse204) & {
  headers: Headers;
};
export type pushUnsubscribeResponseError = (pushUnsubscribeResponseDefault) & {
  headers: Headers;
};

export type pushUnsubscribeResponse = (pushUnsubscribeResponseSuccess | pushUnsubscribeResponseError)

export const getPushUnsubscribeUrl = (params: PushUnsubscribeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/me/push?${stringifiedParams}` : `/me/push`
}

/**
 * @summary Отписать браузер
 */
export const pushUnsubscribe = async (params: PushUnsubscribeParams, options?: Parameters<typeof apiFetch>[1]): Promise<pushUnsubscribeResponse> => {

  return apiFetch<pushUnsubscribeResponse>(getPushUnsubscribeUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPushUnsubscribeQueryKey = (params?: PushUnsubscribeParams,) => {
    return [
    'DELETE', `/me/push`, ...(params ? [params] : [])
    ] as const;
    }


export const getPushUnsubscribeQueryOptions = <TData = Awaited<ReturnType<typeof pushUnsubscribe>>, TError = ErrorModel>(params: PushUnsubscribeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushUnsubscribe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPushUnsubscribeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pushUnsubscribe>>> = ({ signal }) => pushUnsubscribe(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pushUnsubscribe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PushUnsubscribeQueryResult = NonNullable<Awaited<ReturnType<typeof pushUnsubscribe>>>
export type PushUnsubscribeQueryError = ErrorModel


export function usePushUnsubscribe<TData = Awaited<ReturnType<typeof pushUnsubscribe>>, TError = ErrorModel>(
 params: PushUnsubscribeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushUnsubscribe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pushUnsubscribe>>,
          TError,
          Awaited<ReturnType<typeof pushUnsubscribe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePushUnsubscribe<TData = Awaited<ReturnType<typeof pushUnsubscribe>>, TError = ErrorModel>(
 params: PushUnsubscribeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushUnsubscribe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pushUnsubscribe>>,
          TError,
          Awaited<ReturnType<typeof pushUnsubscribe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePushUnsubscribe<TData = Awaited<ReturnType<typeof pushUnsubscribe>>, TError = ErrorModel>(
 params: PushUnsubscribeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushUnsubscribe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отписать браузер
 */

export function usePushUnsubscribe<TData = Awaited<ReturnType<typeof pushUnsubscribe>>, TError = ErrorModel>(
 params: PushUnsubscribeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushUnsubscribe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPushUnsubscribeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type pushStatusResponse200 = {
  data: PushStatusOutputBody
  status: 200
}

export type pushStatusResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type pushStatusResponseSuccess = (pushStatusResponse200) & {
  headers: Headers;
};
export type pushStatusResponseError = (pushStatusResponseDefault) & {
  headers: Headers;
};

export type pushStatusResponse = (pushStatusResponseSuccess | pushStatusResponseError)

export const getPushStatusUrl = (params?: PushStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/me/push?${stringifiedParams}` : `/me/push`
}

/**
 * @summary Web push: ключ и состояние
 */
export const pushStatus = async (params?: PushStatusParams, options?: Parameters<typeof apiFetch>[1]): Promise<pushStatusResponse> => {

  return apiFetch<pushStatusResponse>(getPushStatusUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPushStatusQueryKey = (params?: PushStatusParams,) => {
    return [
    `/me/push`, ...(params ? [params] : [])
    ] as const;
    }


export const getPushStatusQueryOptions = <TData = Awaited<ReturnType<typeof pushStatus>>, TError = ErrorModel>(params?: PushStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPushStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pushStatus>>> = ({ signal }) => pushStatus(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pushStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PushStatusQueryResult = NonNullable<Awaited<ReturnType<typeof pushStatus>>>
export type PushStatusQueryError = ErrorModel


export function usePushStatus<TData = Awaited<ReturnType<typeof pushStatus>>, TError = ErrorModel>(
 params: undefined |  PushStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pushStatus>>,
          TError,
          Awaited<ReturnType<typeof pushStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePushStatus<TData = Awaited<ReturnType<typeof pushStatus>>, TError = ErrorModel>(
 params?: PushStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pushStatus>>,
          TError,
          Awaited<ReturnType<typeof pushStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePushStatus<TData = Awaited<ReturnType<typeof pushStatus>>, TError = ErrorModel>(
 params?: PushStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Web push: ключ и состояние
 */

export function usePushStatus<TData = Awaited<ReturnType<typeof pushStatus>>, TError = ErrorModel>(
 params?: PushStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPushStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type pushSubscribeResponse204 = {
  data: void
  status: 204
}

export type pushSubscribeResponse422 = {
  data: ErrorModel
  status: 422
}

export type pushSubscribeResponse500 = {
  data: ErrorModel
  status: 500
}

export type pushSubscribeResponse503 = {
  data: ErrorModel
  status: 503
}

export type pushSubscribeResponseSuccess = (pushSubscribeResponse204) & {
  headers: Headers;
};
export type pushSubscribeResponseError = (pushSubscribeResponse422 | pushSubscribeResponse500 | pushSubscribeResponse503) & {
  headers: Headers;
};

export type pushSubscribeResponse = (pushSubscribeResponseSuccess | pushSubscribeResponseError)

export const getPushSubscribeUrl = () => {




  return `/me/push`
}

/**
 * Тело — результат pushManager.subscribe().toJSON(). Повторная подписка того же endpoint — обновление.
 * @summary Подписать этот браузер
 */
export const pushSubscribe = async (pushSubscribeInputBody: NonReadonly<PushSubscribeInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<pushSubscribeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<pushSubscribeResponse>(getPushSubscribeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pushSubscribeInputBody)
  }
);}





export const getPushSubscribeQueryKey = (pushSubscribeInputBody?: NonReadonly<PushSubscribeInputBody>,) => {
    return [
    'POST', `/me/push`, pushSubscribeInputBody
    ] as const;
    }


export const getPushSubscribeQueryOptions = <TData = Awaited<ReturnType<typeof pushSubscribe>>, TError = ErrorModel>(pushSubscribeInputBody: NonReadonly<PushSubscribeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushSubscribe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPushSubscribeQueryKey(pushSubscribeInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pushSubscribe>>> = ({ signal }) => pushSubscribe(pushSubscribeInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pushSubscribe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PushSubscribeQueryResult = NonNullable<Awaited<ReturnType<typeof pushSubscribe>>>
export type PushSubscribeQueryError = ErrorModel


export function usePushSubscribe<TData = Awaited<ReturnType<typeof pushSubscribe>>, TError = ErrorModel>(
 pushSubscribeInputBody: NonReadonly<PushSubscribeInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushSubscribe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pushSubscribe>>,
          TError,
          Awaited<ReturnType<typeof pushSubscribe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePushSubscribe<TData = Awaited<ReturnType<typeof pushSubscribe>>, TError = ErrorModel>(
 pushSubscribeInputBody: NonReadonly<PushSubscribeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushSubscribe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pushSubscribe>>,
          TError,
          Awaited<ReturnType<typeof pushSubscribe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePushSubscribe<TData = Awaited<ReturnType<typeof pushSubscribe>>, TError = ErrorModel>(
 pushSubscribeInputBody: NonReadonly<PushSubscribeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushSubscribe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Подписать этот браузер
 */

export function usePushSubscribe<TData = Awaited<ReturnType<typeof pushSubscribe>>, TError = ErrorModel>(
 pushSubscribeInputBody: NonReadonly<PushSubscribeInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushSubscribe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPushSubscribeQueryOptions(pushSubscribeInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type telegramUnlinkResponse204 = {
  data: void
  status: 204
}

export type telegramUnlinkResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 204>
}

export type telegramUnlinkResponseSuccess = (telegramUnlinkResponse204) & {
  headers: Headers;
};
export type telegramUnlinkResponseError = (telegramUnlinkResponseDefault) & {
  headers: Headers;
};

export type telegramUnlinkResponse = (telegramUnlinkResponseSuccess | telegramUnlinkResponseError)

export const getTelegramUnlinkUrl = () => {




  return `/me/telegram`
}

/**
 * @summary Отвязать Telegram
 */
export const telegramUnlink = async ( options?: Parameters<typeof apiFetch>[1]): Promise<telegramUnlinkResponse> => {

  return apiFetch<telegramUnlinkResponse>(getTelegramUnlinkUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTelegramUnlinkQueryKey = () => {
    return [
    'DELETE', `/me/telegram`
    ] as const;
    }


export const getTelegramUnlinkQueryOptions = <TData = Awaited<ReturnType<typeof telegramUnlink>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramUnlink>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelegramUnlinkQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof telegramUnlink>>> = ({ signal }) => telegramUnlink({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telegramUnlink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TelegramUnlinkQueryResult = NonNullable<Awaited<ReturnType<typeof telegramUnlink>>>
export type TelegramUnlinkQueryError = ErrorModel


export function useTelegramUnlink<TData = Awaited<ReturnType<typeof telegramUnlink>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramUnlink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof telegramUnlink>>,
          TError,
          Awaited<ReturnType<typeof telegramUnlink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelegramUnlink<TData = Awaited<ReturnType<typeof telegramUnlink>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramUnlink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof telegramUnlink>>,
          TError,
          Awaited<ReturnType<typeof telegramUnlink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelegramUnlink<TData = Awaited<ReturnType<typeof telegramUnlink>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramUnlink>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отвязать Telegram
 */

export function useTelegramUnlink<TData = Awaited<ReturnType<typeof telegramUnlink>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramUnlink>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTelegramUnlinkQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type telegramStatusResponse200 = {
  data: TelegramStatusOutputBody
  status: 200
}

export type telegramStatusResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type telegramStatusResponseSuccess = (telegramStatusResponse200) & {
  headers: Headers;
};
export type telegramStatusResponseError = (telegramStatusResponseDefault) & {
  headers: Headers;
};

export type telegramStatusResponse = (telegramStatusResponseSuccess | telegramStatusResponseError)

export const getTelegramStatusUrl = () => {




  return `/me/telegram`
}

/**
 * @summary Мой Telegram
 */
export const telegramStatus = async ( options?: Parameters<typeof apiFetch>[1]): Promise<telegramStatusResponse> => {

  return apiFetch<telegramStatusResponse>(getTelegramStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTelegramStatusQueryKey = () => {
    return [
    `/me/telegram`
    ] as const;
    }


export const getTelegramStatusQueryOptions = <TData = Awaited<ReturnType<typeof telegramStatus>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelegramStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof telegramStatus>>> = ({ signal }) => telegramStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telegramStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TelegramStatusQueryResult = NonNullable<Awaited<ReturnType<typeof telegramStatus>>>
export type TelegramStatusQueryError = ErrorModel


export function useTelegramStatus<TData = Awaited<ReturnType<typeof telegramStatus>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof telegramStatus>>,
          TError,
          Awaited<ReturnType<typeof telegramStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelegramStatus<TData = Awaited<ReturnType<typeof telegramStatus>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof telegramStatus>>,
          TError,
          Awaited<ReturnType<typeof telegramStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelegramStatus<TData = Awaited<ReturnType<typeof telegramStatus>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Мой Telegram
 */

export function useTelegramStatus<TData = Awaited<ReturnType<typeof telegramStatus>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTelegramStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type telegramBoardsResponse200 = {
  data: TelegramBoardsOutputBody
  status: 200
}

export type telegramBoardsResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type telegramBoardsResponseSuccess = (telegramBoardsResponse200) & {
  headers: Headers;
};
export type telegramBoardsResponseError = (telegramBoardsResponseDefault) & {
  headers: Headers;
};

export type telegramBoardsResponse = (telegramBoardsResponseSuccess | telegramBoardsResponseError)

export const getTelegramBoardsUrl = () => {




  return `/me/telegram/boards`
}

/**
 * Доски, куда человек может складывать задачи: во всех его организациях, кроме шаблонных проектов и проектов, куда его не добавили.
 * @summary Доски для задач из Telegram
 */
export const telegramBoards = async ( options?: Parameters<typeof apiFetch>[1]): Promise<telegramBoardsResponse> => {

  return apiFetch<telegramBoardsResponse>(getTelegramBoardsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTelegramBoardsQueryKey = () => {
    return [
    `/me/telegram/boards`
    ] as const;
    }


export const getTelegramBoardsQueryOptions = <TData = Awaited<ReturnType<typeof telegramBoards>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramBoards>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelegramBoardsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof telegramBoards>>> = ({ signal }) => telegramBoards({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telegramBoards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TelegramBoardsQueryResult = NonNullable<Awaited<ReturnType<typeof telegramBoards>>>
export type TelegramBoardsQueryError = ErrorModel


export function useTelegramBoards<TData = Awaited<ReturnType<typeof telegramBoards>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramBoards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof telegramBoards>>,
          TError,
          Awaited<ReturnType<typeof telegramBoards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelegramBoards<TData = Awaited<ReturnType<typeof telegramBoards>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramBoards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof telegramBoards>>,
          TError,
          Awaited<ReturnType<typeof telegramBoards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelegramBoards<TData = Awaited<ReturnType<typeof telegramBoards>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramBoards>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Доски для задач из Telegram
 */

export function useTelegramBoards<TData = Awaited<ReturnType<typeof telegramBoards>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramBoards>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTelegramBoardsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type telegramCodeResponse200 = {
  data: TelegramCodeOutputBody
  status: 200
}

export type telegramCodeResponse500 = {
  data: ErrorModel
  status: 500
}

export type telegramCodeResponse503 = {
  data: ErrorModel
  status: 503
}

export type telegramCodeResponseSuccess = (telegramCodeResponse200) & {
  headers: Headers;
};
export type telegramCodeResponseError = (telegramCodeResponse500 | telegramCodeResponse503) & {
  headers: Headers;
};

export type telegramCodeResponse = (telegramCodeResponseSuccess | telegramCodeResponseError)

export const getTelegramCodeUrl = () => {




  return `/me/telegram/code`
}

/**
 * Одноразовый код на 15 минут. Отправить боту «/start КОД» или открыть ссылку.
 * @summary Код привязки Telegram
 */
export const telegramCode = async ( options?: Parameters<typeof apiFetch>[1]): Promise<telegramCodeResponse> => {

  return apiFetch<telegramCodeResponse>(getTelegramCodeUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getTelegramCodeQueryKey = () => {
    return [
    'POST', `/me/telegram/code`
    ] as const;
    }


export const getTelegramCodeQueryOptions = <TData = Awaited<ReturnType<typeof telegramCode>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramCode>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelegramCodeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof telegramCode>>> = ({ signal }) => telegramCode({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telegramCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TelegramCodeQueryResult = NonNullable<Awaited<ReturnType<typeof telegramCode>>>
export type TelegramCodeQueryError = ErrorModel


export function useTelegramCode<TData = Awaited<ReturnType<typeof telegramCode>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof telegramCode>>,
          TError,
          Awaited<ReturnType<typeof telegramCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelegramCode<TData = Awaited<ReturnType<typeof telegramCode>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof telegramCode>>,
          TError,
          Awaited<ReturnType<typeof telegramCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelegramCode<TData = Awaited<ReturnType<typeof telegramCode>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramCode>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Код привязки Telegram
 */

export function useTelegramCode<TData = Awaited<ReturnType<typeof telegramCode>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramCode>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTelegramCodeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type telegramSetInboxResponse200 = {
  data: TelegramStatusOutputBody
  status: 200
}

export type telegramSetInboxResponse404 = {
  data: ErrorModel
  status: 404
}

export type telegramSetInboxResponse422 = {
  data: ErrorModel
  status: 422
}

export type telegramSetInboxResponse500 = {
  data: ErrorModel
  status: 500
}

export type telegramSetInboxResponseSuccess = (telegramSetInboxResponse200) & {
  headers: Headers;
};
export type telegramSetInboxResponseError = (telegramSetInboxResponse404 | telegramSetInboxResponse422 | telegramSetInboxResponse500) & {
  headers: Headers;
};

export type telegramSetInboxResponse = (telegramSetInboxResponseSuccess | telegramSetInboxResponseError)

export const getTelegramSetInboxUrl = () => {




  return `/me/telegram/inbox`
}

/**
 * Куда бот складывает задачи из сообщений. Недоступная доска — 404, как и всё чужое.
 * @summary Входящая доска Telegram
 */
export const telegramSetInbox = async (telegramInboxInputBody: NonReadonly<TelegramInboxInputBody>, options?: Parameters<typeof apiFetch>[1]): Promise<telegramSetInboxResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<telegramSetInboxResponse>(getTelegramSetInboxUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(telegramInboxInputBody)
  }
);}





export const getTelegramSetInboxQueryKey = (telegramInboxInputBody?: NonReadonly<TelegramInboxInputBody>,) => {
    return [
    'PUT', `/me/telegram/inbox`, telegramInboxInputBody
    ] as const;
    }


export const getTelegramSetInboxQueryOptions = <TData = Awaited<ReturnType<typeof telegramSetInbox>>, TError = ErrorModel>(telegramInboxInputBody: NonReadonly<TelegramInboxInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramSetInbox>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelegramSetInboxQueryKey(telegramInboxInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof telegramSetInbox>>> = ({ signal }) => telegramSetInbox(telegramInboxInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telegramSetInbox>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TelegramSetInboxQueryResult = NonNullable<Awaited<ReturnType<typeof telegramSetInbox>>>
export type TelegramSetInboxQueryError = ErrorModel


export function useTelegramSetInbox<TData = Awaited<ReturnType<typeof telegramSetInbox>>, TError = ErrorModel>(
 telegramInboxInputBody: NonReadonly<TelegramInboxInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramSetInbox>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof telegramSetInbox>>,
          TError,
          Awaited<ReturnType<typeof telegramSetInbox>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelegramSetInbox<TData = Awaited<ReturnType<typeof telegramSetInbox>>, TError = ErrorModel>(
 telegramInboxInputBody: NonReadonly<TelegramInboxInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramSetInbox>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof telegramSetInbox>>,
          TError,
          Awaited<ReturnType<typeof telegramSetInbox>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTelegramSetInbox<TData = Awaited<ReturnType<typeof telegramSetInbox>>, TError = ErrorModel>(
 telegramInboxInputBody: NonReadonly<TelegramInboxInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramSetInbox>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Входящая доска Telegram
 */

export function useTelegramSetInbox<TData = Awaited<ReturnType<typeof telegramSetInbox>>, TError = ErrorModel>(
 telegramInboxInputBody: NonReadonly<TelegramInboxInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof telegramSetInbox>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTelegramSetInboxQueryOptions(telegramInboxInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type notificationsListResponse200 = {
  data: FeedBody
  status: 200
}

export type notificationsListResponse404 = {
  data: ErrorModel
  status: 404
}

export type notificationsListResponse422 = {
  data: ErrorModel
  status: 422
}

export type notificationsListResponse500 = {
  data: ErrorModel
  status: 500
}

export type notificationsListResponseSuccess = (notificationsListResponse200) & {
  headers: Headers;
};
export type notificationsListResponseError = (notificationsListResponse404 | notificationsListResponse422 | notificationsListResponse500) & {
  headers: Headers;
};

export type notificationsListResponse = (notificationsListResponseSuccess | notificationsListResponseError)

export const getNotificationsListUrl = (workspace: string,
    params?: NotificationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/workspaces/${workspace}/notifications?${stringifiedParams}` : `/workspaces/${workspace}/notifications`
}

/**
 * Уведомления того, кто спрашивает, новые сверху. С числом непрочитанных.
 * @summary Входящие
 */
export const notificationsList = async (workspace: string,
    params?: NotificationsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<notificationsListResponse> => {

  return apiFetch<notificationsListResponse>(getNotificationsListUrl(workspace,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getNotificationsListQueryKey = (workspace: string,
    params?: NotificationsListParams,) => {
    return [
    `/workspaces/${workspace}/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getNotificationsListQueryOptions = <TData = Awaited<ReturnType<typeof notificationsList>>, TError = ErrorModel>(workspace: string,
    params?: NotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsListQueryKey(workspace,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsList>>> = ({ signal }) => notificationsList(workspace,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsList>>>
export type NotificationsListQueryError = ErrorModel


export function useNotificationsList<TData = Awaited<ReturnType<typeof notificationsList>>, TError = ErrorModel>(
 workspace: string,
    params: undefined |  NotificationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsList>>,
          TError,
          Awaited<ReturnType<typeof notificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsList<TData = Awaited<ReturnType<typeof notificationsList>>, TError = ErrorModel>(
 workspace: string,
    params?: NotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsList>>,
          TError,
          Awaited<ReturnType<typeof notificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsList<TData = Awaited<ReturnType<typeof notificationsList>>, TError = ErrorModel>(
 workspace: string,
    params?: NotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Входящие
 */

export function useNotificationsList<TData = Awaited<ReturnType<typeof notificationsList>>, TError = ErrorModel>(
 workspace: string,
    params?: NotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsListQueryOptions(workspace,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type notificationsReadAllResponse204 = {
  data: void
  status: 204
}

export type notificationsReadAllResponse404 = {
  data: ErrorModel
  status: 404
}

export type notificationsReadAllResponse422 = {
  data: ErrorModel
  status: 422
}

export type notificationsReadAllResponse500 = {
  data: ErrorModel
  status: 500
}

export type notificationsReadAllResponseSuccess = (notificationsReadAllResponse204) & {
  headers: Headers;
};
export type notificationsReadAllResponseError = (notificationsReadAllResponse404 | notificationsReadAllResponse422 | notificationsReadAllResponse500) & {
  headers: Headers;
};

export type notificationsReadAllResponse = (notificationsReadAllResponseSuccess | notificationsReadAllResponseError)

export const getNotificationsReadAllUrl = (workspace: string,) => {




  return `/workspaces/${workspace}/notifications/read-all`
}

/**
 * @summary Прочитать всё
 */
export const notificationsReadAll = async (workspace: string, options?: Parameters<typeof apiFetch>[1]): Promise<notificationsReadAllResponse> => {

  return apiFetch<notificationsReadAllResponse>(getNotificationsReadAllUrl(workspace),
  {
    ...options,
    method: 'POST'


  }
);}





export const getNotificationsReadAllQueryKey = (workspace: string,) => {
    return [
    'POST', `/workspaces/${workspace}/notifications/read-all`
    ] as const;
    }


export const getNotificationsReadAllQueryOptions = <TData = Awaited<ReturnType<typeof notificationsReadAll>>, TError = ErrorModel>(workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsReadAll>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsReadAllQueryKey(workspace);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsReadAll>>> = ({ signal }) => notificationsReadAll(workspace, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsReadAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsReadAllQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsReadAll>>>
export type NotificationsReadAllQueryError = ErrorModel


export function useNotificationsReadAll<TData = Awaited<ReturnType<typeof notificationsReadAll>>, TError = ErrorModel>(
 workspace: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsReadAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsReadAll>>,
          TError,
          Awaited<ReturnType<typeof notificationsReadAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsReadAll<TData = Awaited<ReturnType<typeof notificationsReadAll>>, TError = ErrorModel>(
 workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsReadAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsReadAll>>,
          TError,
          Awaited<ReturnType<typeof notificationsReadAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsReadAll<TData = Awaited<ReturnType<typeof notificationsReadAll>>, TError = ErrorModel>(
 workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsReadAll>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Прочитать всё
 */

export function useNotificationsReadAll<TData = Awaited<ReturnType<typeof notificationsReadAll>>, TError = ErrorModel>(
 workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsReadAll>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsReadAllQueryOptions(workspace,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type notificationsUnreadResponse200 = {
  data: UnreadOutputBody
  status: 200
}

export type notificationsUnreadResponse404 = {
  data: ErrorModel
  status: 404
}

export type notificationsUnreadResponse422 = {
  data: ErrorModel
  status: 422
}

export type notificationsUnreadResponse500 = {
  data: ErrorModel
  status: 500
}

export type notificationsUnreadResponseSuccess = (notificationsUnreadResponse200) & {
  headers: Headers;
};
export type notificationsUnreadResponseError = (notificationsUnreadResponse404 | notificationsUnreadResponse422 | notificationsUnreadResponse500) & {
  headers: Headers;
};

export type notificationsUnreadResponse = (notificationsUnreadResponseSuccess | notificationsUnreadResponseError)

export const getNotificationsUnreadUrl = (workspace: string,) => {




  return `/workspaces/${workspace}/notifications/unread`
}

/**
 * @summary Число непрочитанных
 */
export const notificationsUnread = async (workspace: string, options?: Parameters<typeof apiFetch>[1]): Promise<notificationsUnreadResponse> => {

  return apiFetch<notificationsUnreadResponse>(getNotificationsUnreadUrl(workspace),
  {
    ...options,
    method: 'GET'


  }
);}





export const getNotificationsUnreadQueryKey = (workspace: string,) => {
    return [
    `/workspaces/${workspace}/notifications/unread`
    ] as const;
    }


export const getNotificationsUnreadQueryOptions = <TData = Awaited<ReturnType<typeof notificationsUnread>>, TError = ErrorModel>(workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsUnread>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsUnreadQueryKey(workspace);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsUnread>>> = ({ signal }) => notificationsUnread(workspace, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsUnread>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsUnreadQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsUnread>>>
export type NotificationsUnreadQueryError = ErrorModel


export function useNotificationsUnread<TData = Awaited<ReturnType<typeof notificationsUnread>>, TError = ErrorModel>(
 workspace: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsUnread>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsUnread>>,
          TError,
          Awaited<ReturnType<typeof notificationsUnread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsUnread<TData = Awaited<ReturnType<typeof notificationsUnread>>, TError = ErrorModel>(
 workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsUnread>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsUnread>>,
          TError,
          Awaited<ReturnType<typeof notificationsUnread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsUnread<TData = Awaited<ReturnType<typeof notificationsUnread>>, TError = ErrorModel>(
 workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsUnread>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Число непрочитанных
 */

export function useNotificationsUnread<TData = Awaited<ReturnType<typeof notificationsUnread>>, TError = ErrorModel>(
 workspace: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsUnread>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsUnreadQueryOptions(workspace,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type notificationsReadResponse204 = {
  data: void
  status: 204
}

export type notificationsReadResponse404 = {
  data: ErrorModel
  status: 404
}

export type notificationsReadResponse422 = {
  data: ErrorModel
  status: 422
}

export type notificationsReadResponse500 = {
  data: ErrorModel
  status: 500
}

export type notificationsReadResponseSuccess = (notificationsReadResponse204) & {
  headers: Headers;
};
export type notificationsReadResponseError = (notificationsReadResponse404 | notificationsReadResponse422 | notificationsReadResponse500) & {
  headers: Headers;
};

export type notificationsReadResponse = (notificationsReadResponseSuccess | notificationsReadResponseError)

export const getNotificationsReadUrl = (workspace: string,
    id: string,) => {




  return `/workspaces/${workspace}/notifications/${id}/read`
}

/**
 * @summary Прочитано
 */
export const notificationsRead = async (workspace: string,
    id: string, options?: Parameters<typeof apiFetch>[1]): Promise<notificationsReadResponse> => {

  return apiFetch<notificationsReadResponse>(getNotificationsReadUrl(workspace,id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getNotificationsReadQueryKey = (workspace: string,
    id: string,) => {
    return [
    'POST', `/workspaces/${workspace}/notifications/${id}/read`
    ] as const;
    }


export const getNotificationsReadQueryOptions = <TData = Awaited<ReturnType<typeof notificationsRead>>, TError = ErrorModel>(workspace: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsRead>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsReadQueryKey(workspace,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsRead>>> = ({ signal }) => notificationsRead(workspace,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workspace !== null && workspace !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsRead>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsReadQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsRead>>>
export type NotificationsReadQueryError = ErrorModel


export function useNotificationsRead<TData = Awaited<ReturnType<typeof notificationsRead>>, TError = ErrorModel>(
 workspace: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsRead>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsRead>>,
          TError,
          Awaited<ReturnType<typeof notificationsRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsRead<TData = Awaited<ReturnType<typeof notificationsRead>>, TError = ErrorModel>(
 workspace: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsRead>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsRead>>,
          TError,
          Awaited<ReturnType<typeof notificationsRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsRead<TData = Awaited<ReturnType<typeof notificationsRead>>, TError = ErrorModel>(
 workspace: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsRead>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Прочитано
 */

export function useNotificationsRead<TData = Awaited<ReturnType<typeof notificationsRead>>, TError = ErrorModel>(
 workspace: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsRead>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsReadQueryOptions(workspace,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






